import React, { useEffect, useState } from 'react';
import { auth, provider } from '../firebase-folder/firebase';
import { signInWithPopup, signOut, onAuthStateChanged } from 'firebase/auth';

const LoginComponent = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  const handleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      setUser(result.user);
    } catch (err) {
      console.error('Login error:', err);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setUser(null);
    } catch (err) {
      console.error('Sign out error:', err);
    }
  };

  return (
    <div>
      {user ? (
        <>
          <h2>Welcome, {user.displayName}</h2>
          <img src={user.photoURL} alt="Profile" width="100" />
          <ul>
            <li><strong>UID:</strong> {user.uid}</li>
            <li><strong>Email:</strong> {user.email}</li>
            <li><strong>Email Verified:</strong> {user.emailVerified ? 'Yes' : 'No'}</li>
            <li><strong>Provider:</strong> {user.providerId}</li>
            <li><strong>Account Created:</strong> {user.metadata.creationTime}</li>
            <li><strong>Last Sign-in:</strong> {user.metadata.lastSignInTime}</li>
          </ul>
          <button onClick={handleLogout}>Sign Out</button>
        </>
      ) : (
        <button onClick={handleLogin}>Sign In with Google</button>
      )}
    </div>
  );
};

export default LoginComponent;